var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px" } },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "name", $$v)
                          },
                          expression: "searchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "五域商品编号", prop: "goodsNo" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "232px" },
                        attrs: { placeholder: "请输入商品编号" },
                        model: {
                          value: _vm.searchForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsNo", $$v)
                          },
                          expression: "searchForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品来源", prop: "origin" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请选择商品来源",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.origin,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "origin", $$v)
                            },
                            expression: "searchForm.origin",
                          },
                        },
                        _vm._l(_vm.originList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类型", prop: "goodsType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请选择商品类型",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.goodsType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "goodsType", $$v)
                            },
                            expression: "searchForm.goodsType",
                          },
                        },
                        _vm._l(_vm.goods_types, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        _vm._l(_vm.dictionaries.sale_status, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类目", prop: "categoryIds" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "232px" },
                        attrs: {
                          options: _vm.categoryIds,
                          props: {
                            checkStrictly: true,
                            multiple: true,
                            emitPath: false,
                          },
                          "collapse-tags": "",
                          clearable: "",
                        },
                        on: { change: _vm.onChangeCategory },
                        model: {
                          value: _vm.searchForm.categoryIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "categoryIds", $$v)
                          },
                          expression: "searchForm.categoryIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "分类标签",
                        prop: "tagId",
                        "label-width": "96px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "232px" },
                          attrs: {
                            placeholder: "请选择分类标签",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.searchForm.tagId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "tagId", $$v)
                            },
                            expression: "searchForm.tagId",
                          },
                        },
                        _vm._l(_vm.tags, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.tagName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("h3", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(" 列表数据"),
          _c(
            "span",
            {
              staticStyle: {
                color: "#f63c56",
                "font-size": "14px",
                "margin-left": "12px",
              },
            },
            [_vm._v("剩余可上架数量（" + _vm._s(_vm.surNum) + "）")]
          ),
        ]),
        _c("div", { staticClass: "btn-list" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.selectData },
                  model: {
                    value: _vm.radio1,
                    callback: function ($$v) {
                      _vm.radio1 = $$v
                    },
                    expression: "radio1",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: " ", border: "" } }, [
                    _vm._v(
                      "全部(" +
                        _vm._s(
                          _vm.countGroupByStatus.psGoodsTotalUp +
                            _vm.countGroupByStatus.psGoodsTotalDown
                        ) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "1" } }, [
                    _vm._v(
                      "已上架(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotalUp) +
                        ")"
                    ),
                  ]),
                  _c("el-radio-button", { attrs: { label: "0" } }, [
                    _vm._v(
                      "已下架(" +
                        _vm._s(_vm.countGroupByStatus.psGoodsTotalDown) +
                        ")"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "92px" },
                  attrs: {
                    type: "warning",
                    disabled:
                      _vm.currentStatus === _vm.groupByStatus.onSaleCount
                        ? true
                        : false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toApply()
                    },
                  },
                },
                [_vm._v("商品审核")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "106px" },
                  attrs: {
                    type: "warning",
                    disabled:
                      _vm.currentStatus === _vm.groupByStatus.offSaleCount
                        ? true
                        : false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toAwait()
                    },
                  },
                },
                [_vm._v("待上架商品")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "142px" },
                  attrs: { type: "primary", icon: "el-icon-edit" },
                  on: {
                    click: function ($event) {
                      return _vm.toEditTag()
                    },
                  },
                },
                [_vm._v("批量修改标签")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.add },
                },
                [_vm._v("添加商品")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-upload2" },
                  on: {
                    click: function ($event) {
                      return _vm.exportData()
                    },
                  },
                },
                [_vm._v("批量导出")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isLimit,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isLimit = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "orange", "font-size": "20px" },
              }),
              _vm._v(
                "您已新增上架商品 " +
                  _vm._s(_vm.numberY) +
                  " 个，已达新增上架商品上限，若想继续新增商品，请下架其中一个商品； "
              ),
            ]),
            _c("div", { staticClass: "info-b" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
              _vm._v(" 若增加上架个数，请联系客服！ "),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isLimit = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.sLimit()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isSdown,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSdown = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "info", staticStyle: { "text-align": "left" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "orange", "font-size": "20px" },
                }),
                _vm._v("该商品五域系统已下架，平台不能再上架！ "),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isSdown = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        _vm.isSdown = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isSdown1,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSdown1 = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "info", staticStyle: { "text-align": "left" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "orange", "font-size": "20px" },
                }),
                _vm._v("来源平台下架，同步的所有平台都下架! "),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isSdown1 = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.sUpData } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择标签",
            visible: _vm.isTag,
            width: "40%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isTag = $event
            },
          },
        },
        [
          [
            _c("div", [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticStyle: { "line-height": "30px" } }, [
                  _vm._v("标签名称"),
                ]),
                _c(
                  "div",
                  { staticStyle: { "margin-left": "20px" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入标签名称", size: "small" },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-left": "20px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData1("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData1("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c("lb-table", {
                    directives: [
                      {
                        name: "horizontal-scroll",
                        rawName: "v-horizontal-scroll",
                        value: "always",
                        expression: "'always'",
                      },
                    ],
                    attrs: {
                      column: _vm.columnsT,
                      data: _vm.tagList,
                      pagination: "",
                      total: _vm.totalNum,
                      layout: "total, sizes, prev, pager, next, jumper",
                      "page-sizes": [5, 10, 20, 30, 50],
                      "current-page": _vm.pageNo,
                      "page-size": _vm.pageSize,
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.pageNo = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.pageNo = $event
                      },
                      "selection-change": _vm.onMultipleSelection,
                      "size-change": _vm.handleSizeChange1,
                      "p-current-change": _vm.handleCurrentChange1,
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "center",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.upTags()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }